import React from "react";
import MyMessagesAlert from "./widget/MyMessagesAlert";
import { MyMessagesContextProvider } from "../../../provider/work_profile/my_messages/MyMessagesContextProvider";

const MyMessagesContent = (props: {
  isModal?: boolean;
  fromChat?: boolean;
}) => {
  const fromChat: boolean = props.fromChat ?? false;

  return (
    <MyMessagesContextProvider>
      <MyMessagesAlert fromChat={fromChat} />
    </MyMessagesContextProvider>
  );
};

export default MyMessagesContent;
